import { z } from 'zod';
/** Wersja protokołu. Zmiana = niezgodność wsteczna; klient dostaje wtedy prośbę o odświeżenie. */
export const PROTOCOL_VERSION = 1;
export const seatSchema = z.union([z.literal(0), z.literal(1)]);
export const orientationSchema = z.enum(['h', 'v']);
export const shipSizeSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
export const coordSchema = z.object({
    x: z.number().int().min(0).max(25),
    y: z.number().int().min(0).max(25),
});
export const shipSchema = z.object({
    id: z.number().int().min(0).max(63),
    size: shipSizeSchema,
    x: z.number().int().min(0).max(25),
    y: z.number().int().min(0).max(25),
    dir: orientationSchema,
});
/** Górny limit liczby statków jest zabezpieczeniem przed ramką-bombą, nie regułą gry. */
export const fleetSchema = z.array(shipSchema).min(1).max(32);
export const rosterSchema = z.object({
    1: z.number().int().min(0).max(16),
    2: z.number().int().min(0).max(16),
    3: z.number().int().min(0).max(16),
    4: z.number().int().min(0).max(16),
});
export const rulesetSchema = z.object({
    boardSize: z.number().int().min(5).max(20),
    roster: rosterSchema,
    extraShotOnHit: z.boolean(),
    autoRevealHaloOnSunk: z.boolean(),
    /** `null` = bez limitu czasu (ustawienie domyślne). */
    turnTimeoutSec: z.number().int().min(5).max(600).nullable(),
    placementTimeoutSec: z.number().int().min(10).max(3600).nullable(),
});
export const shotResultSchema = z.enum(['miss', 'hit', 'sunk']);
export const shotSchema = z.object({
    x: z.number().int().min(0).max(25),
    y: z.number().int().min(0).max(25),
    result: shotResultSchema,
    shipId: z.number().int().min(0).max(63).optional(),
});
export const gameStatusSchema = z.enum(['placement', 'in_progress', 'finished']);
export const endReasonSchema = z.enum(['victory', 'resign', 'timeout', 'abandoned', 'cancelled']);
/** Trzy poziomy bota — patrz `@sea-wars/game-core`'s `BotLevel` (mirror, bez importu w runtime). */
export const botLevelSchema = z.enum(['easy', 'medium', 'hard']);
//# sourceMappingURL=primitives.js.map